import { useScrollReveal } from '@/hooks/useScrollReveal';
import CustomCursor from '@/components/feature/CustomCursor';
import PricingNavbar from './components/PricingNavbar';
import PricingBanner from './components/PricingBanner';
import PricingPlans from './components/PricingPlans';
import PricingAddons from './components/PricingAddons';
import PricingTable from './components/PricingTable';
import PricingDisclaimer from './components/PricingDisclaimer';
import PricingFinalCTA from './components/PricingFinalCTA';
import Footer from '@/pages/home/components/Footer';

export default function Pricing() {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <CustomCursor />
      <PricingNavbar />
      <PricingBanner />
      <PricingPlans />
      <PricingAddons />
      <PricingTable />
      <PricingDisclaimer />
      <PricingFinalCTA />
      <Footer />
    </div>
  );
}
